import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import ReactPlayer from "react-player/youtube";
import { youtubeDialogStyles } from "./styles";

const YoutubeDialog = ({
  classes,
  onClose,
  open,
  label,
  description,
  videoId
}) => {
  return (
    <Dialog
      aria-labelledby={label}
      aria-describedby={description}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      className={classes.root}
    >
      <div className={classes.padding} />
      <div className={classes.playerCtn}>
        <ReactPlayer
          url={`https://www.youtube.com/watch?v=${videoId}`}
          width="100%"
          height="100%"
        />
      </div>
    </Dialog>
  );
};
YoutubeDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string
};

export default withStyles(youtubeDialogStyles)(YoutubeDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/YoutubeDialog.js